import React from 'react';
import { Box, Typography } from '@mui/material';
import OlympiadCard from './OlympiadCard'; // Updated path
import { OlympiadData } from '../../models/OlympiadData';

interface OlympiadSectionProps {
  olympiadData: OlympiadData[];
}

const OlympiadSection: React.FC<OlympiadSectionProps> = ({ olympiadData }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: '#1E232C' }}>
        Olympiads
      </Typography>
      <Box sx={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
        gap: 3 
      }}>
        {olympiadData.map((olympiad, index) => (
          <OlympiadCard key={index} {...olympiad} />
        ))}
      </Box>
    </Box>
  );
};

export default OlympiadSection;